import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, Loader, XCircle } from 'lucide-react';
import Navbar from '../shared/Navbar';

const PaymentCancelled = () => {
    const navigate = useNavigate();


    return (
        <div className="min-h-screen bg-gray-50">
            <Navbar />

            <div className="max-w-2xl mx-auto px-4 py-20">
                <div className="bg-white rounded-2xl shadow-lg p-12 text-center">

                    <>
                        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                            <XCircle className="w-12 h-12 text-red-600" />
                        </div>
                        <h2 className="text-3xl font-bold mb-4">Payment Cancelled</h2>
                        <p className="text-xl text-gray-600 mb-8">Your subscription was not completed.</p>

                        <div className="flex gap-4 justify-center">
                            <button
                                onClick={() => navigate('/parent/dashboard')}
                                className="btn-secondary"
                            >
                                Go Home
                            </button>
                        </div>
                    </>
                </div>
            </div>
        </div>
    );
};

export default PaymentCancelled;